/* eslint-disable no-unused-vars */

import axios from "axios";
import { Delete, Get, Post, PostFormData } from "../Request";
export default {
  state: {
    Announcements: [],
  },
  getters: {
    GetAnnouncement(state) {
      return state.Announcements;
    },
  },
  actions: {
    async PostAnnouncement({ commit }, payload) {
      return await Post("Announcement/AddAnnouncement", payload).then((res) => {
        return res.data;
      });
    },
    async GetAnnouncement({ commit }, payload) {
      return await Get(
        `Announcement/GetAnnouncement?page=${payload.page}&pageSize=${payload.pageSize}`
      ).then((res) => {
        commit("SetAnnouncements", res.data.Data);
        return res.data;
      });
    },
    async EditAnnouncement({ commit }, payload) {
      return await Post("Announcement/EditAnnouncement", payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async DeleteAnnouncement({ commit }, payload) {
      return await Delete(`Announcement/DeleteAnnouncement/${payload}`).then(
        (res) => {
          return res.data;
        }
      );
    },
  },
  mutations: {
    SetAnnouncements(state, payload) {
      state.Announcements = payload;
    },
  },
};
